/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

export const TRANSACTION_STATUS_PAID = 'paid'
export const TRANSACTION_STATUS_PENDING = 'pending'
export const TRANSACTION_STATUS_UNPAID = 'unpaid'

export const TransactionStatusCodes = [
  TRANSACTION_STATUS_PAID,
  TRANSACTION_STATUS_PENDING,
  TRANSACTION_STATUS_UNPAID
]
